<template>
  <el-drawer class="drawer" id="map_drawer" :withHeader="false" :show-close="false" :destroy-on-close="true" :visible.sync="is_open" size="90%"
    direction="btt">
    <div v-if="page == 1">
      <el-row class="row_head_map">
        <el-col :span="24" class="text-center">
          <h2 class="text-title--large">{{ $t('drawer.map.header') }}</h2>
          <vue-google-autocomplete
            id="map"
            ref="address"
            classname="form-control"
            class="search-location"
            :placeholder="$t('drawer.map.placeholder')"
            @keyup="onKeyUpPlacePredictions($event)"
            @placechanged="getUserAddress"
            v-show="false"
          >
          </vue-google-autocomplete>
          <el-input
            v-model="searchAddress"
            class="text-subtitle"
            :placeholder="$t('drawer.map.search')"
            @keyup.native="onKeyUpPlacePredictions($event)"
            ref="search_input"
            id="search-input"
          >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
              <i slot="suffix" class="el-input__icon el-icon-error" @click="clearSearch"></i>
          </el-input>
        </el-col>
      </el-row>
      <div>
        <div id="map_pin" @click="page = 2">
          <el-row class="map-row-list">
            <el-col :span="2" class="mt--1">
              <img src="@/assets/icons/vector.png" width="15">
            </el-col>
            <el-col :span="22" class="text-body">{{ $t('drawer.map.selectmap') }}</el-col>
          </el-row>
        </div>
        <el-row id="gps" class="map-row-list" @click.native="setUserSelectToLocal">
          <el-col :span="2" class="">
            <img src="@/assets/icons/gps.png" width="18">
          </el-col>
          <el-col :span="22" class="text-body">{{ $t('drawer.map.currentlocation') }}</el-col>
          <el-col :span="24" class="text-body color-info--text" v-if="currentAddress === null">{{ $t('drawer.map.nonelocation') }}</el-col>
          <el-col :span="24" class="text-body color-info--text" v-else>{{ currentAddress }}</el-col>
        </el-row>
        <MapList :map_data="PredictionPlace" @getUserSelectPlace="getUserSelectPlace"/>
      </div>
    </div>
      <MapPin v-if="page == 2" @back_page="back_page" @close_map="close_page" :map_item="{}" @distance_info="setDistanceInfo" />
  </el-drawer>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */

import MapList from './MapList'
import MapPin from './MapPin'

import VueGoogleAutocomplete from 'vue-google-autocomplete'
// import { handlePermission } from '@/utils/map'

export default {
  props: {
    is_map:{
      default: false
    }
  },
  components: {
    MapList,
    MapPin,
    VueGoogleAutocomplete
  },
  data() {
    return {
      searchAddress: '',
      is_open: true,
      page: 1,
      PredictionPlace: [],
      currentAddress: null,
      currentLocation: null,
      typingTimer: null
    }
  },
  created() {
  },
  mounted() {
    navigator.geolocation.getCurrentPosition(this.getLatLng,  this.errorCallback, { enableHighAccuracy:true, maximumAge: 0, timeout: 5000 })
    this.$nextTick(()=>{
      if (this.page == 1) {
        this.$refs.search_input.focus();
      }
    })
  },
  methods: {
    errorCallback(error) {
      switch(error.code) {
        case error.TIMEOUT:
          navigator.geolocation.getCurrentPosition(this.getLatLng, this.errorCallback, { enableHighAccuracy:true, maximumAge: 0, timeout: 5000 })
          break
      }
    },
    getLatLng (position) {
      // let crd = position.coords
      this.currentLocation = { lat: position.coords.latitude, lng: position.coords.longitude }
      let geocoder = new google.maps.Geocoder()
      geocoder.geocode({
        'location': {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }
        // 'region': 'th'
      }, this.reverseLatLngToAddress)
    },
    reverseLatLngToAddress (results, status) {
      if (status === 'OK') {
        if (results[0]) {
          this.currentLocation.address = results[0].formatted_address
          // this.$emit('UserAddress', this.currentLocation.address)
          this.currentAddress = this.currentLocation.address

          // recheck duplicate location
          this.recheckDupLocation()

          // this.setUserSelectToLocal()
        } else {
          this.currentAddress = ''
        }
      } else {
        alert('Geocoder failed due to: ' + status)
      }
    },
    async onKeyUpPlacePredictions (event) {

      clearTimeout(this.typingTimer)

      const getPlacePredictions = (service, data) => new Promise((resolve, reject) => {
        service.getPlacePredictions(data, (predictions, status) => {
          if (status === 'OK') {
            resolve(predictions)
          }
        })
      })

      const predictions = (typingAddress) => new Promise((resolve, reject) => {
        var typingTimer = setTimeout(async () => {
          var service = new google.maps.places.AutocompleteService()
          const predictions = await getPlacePredictions(service, {
            input: typingAddress
            // componentRestrictions: { country: 'th' }
          })
          this.PredictionPlace = predictions
        }, 1000)
        resolve(typingTimer)
      })

      if (event.target.value !== '') {
        var typingAddress = event.target.value
        this.typingTimer = await predictions(typingAddress)
      }

    },
    getUserAddress (address, place, id) {
      this.$store.dispatch('setUserAddress', place.formatted_address)
      this.$store.dispatch('setLatLng', { lat: address.latitude, lng: address.longitude })
    },
    getUserSelectPlace (place) {
      var geocoder = new google.maps.Geocoder()
      geocoder.geocode({
        'address': place.description
        // 'region': 'th' },
      }, this.reverseAddressToLatLng)
      // this.$emit('UserAddress', place.description)
      this.$refs.address.update(place.description)
      this.searchAddress = place.description
    },
    reverseAddressToLatLng (results, status) {
      this.currentLocation = {
        lat: results[0].geometry.location.lat(),
        lng: results[0].geometry.location.lng(),
        address: this.searchAddress
      }
      this.setUserSelectToLocal()
    },
    setUserSelectToLocal (location) {
      if (this.currentLocation !== null) {

        // recheck duplicate location
        this.recheckDupLocation()

        localStorage.setItem('fsloc', JSON.stringify(this.currentLocation))
        let location = JSON.parse(localStorage.getItem('fsloc'))
        this.$store.dispatch('calculateDistanceOSRM', {
              origin_coordinates: [this.BranchDetail.latitude, this.BranchDetail.longitude],
              origin_address: this.BranchDetail.address,
              destination_address: this.currentLocation.address,
              destination_coordinates: [location.lat, location.lng]
            }).then((distance) => {
              let noDistance = true
              if(distance !== null && distance !== undefined){
                  noDistance = false
                  this.$store.dispatch('getDistanceInfo', {
                    distance: distance,
                    total: this.TotalCartPrice,
                    location: { lat: location.lat, lng: location.lng, address: location.address },
                    restaurant: this.BranchDetail.restaurantId,
                    branch: this.BranchDetail.id
                  }).then( (response) => {
                    this.$emit('distance_info', response)
                    this.is_open = false
                  })
              }
              if(noDistance){
                this.$store.dispatch('calculateDistanceMatrix', {
                  origin_coordinates: [this.BranchDetail.latitude, this.BranchDetail.longitude],
                  origin_address: this.BranchDetail.address,
                  destination_address: this.currentLocation.address,
                  destination_coordinates: [location.lat, location.lng]
                }).then((distance) => {
                  this.$store.dispatch('getDistanceInfo', {
                    distance: distance,
                    total: this.TotalCartPrice,
                    location: { lat: location.lat, lng: location.lng, address: location.address },
                    restaurant: this.BranchDetail.restaurantId,
                    branch: this.BranchDetail.id
                  }).then( (response) => {
                    this.$emit('distance_info', response)
                    this.is_open = false
                  })
                })
              }
            })
      }
    },
    recheckDupLocation () {
      let loc = JSON.parse(localStorage.getItem('fsloc'))
      if (loc !== null && typeof loc !== 'undefined') {
        if (loc.lat == this.currentLocation.lat && loc.lng == this.currentLocation.lng) {
          this.currentLocation.new = 0
          this.$store.dispatch('setChangeLocation', {
            status: 'old',
            branch: this.BranchDetail,
            location: this.currentLocation
          })
        } else {
          this.currentLocation.new = 1
          this.$store.dispatch('setChangeLocation', {
            status: 'new',
            branch: this.BranchDetail,
            location: this.currentLocation
          })
        }
      } else {
        this.currentLocation.new = 1
        this.$store.dispatch('setChangeLocation', {
          status: 'first',
          branch: this.BranchDetail,
          location: this.currentLocation
        })
      }
    },
    setDistanceInfo (distance) {
      this.$emit('distance_info', distance)
      this.is_open = false
    },
    clearSearch () {
      this.$refs.address.clear()
      this.$refs.search_input.clear()
      this.searchAddress = ''
      this.PredictionPlace = []
    },
    handleInput(evt){
      this.searchAddress = evt;
    },
    back_page() {
      this.page = 1;
    },
    close_page() {
      this.is_open = false;
    }
  },
  computed: {
    BranchDetail () {
      return this.$store.getters.BranchDetail
    },
    TotalCartPrice () {
      return this.$store.getters.TotalCartPrice
    }
  },
  watch:{
    is_open(){
      this.$emit('toggle_search')
    }
  }
};

</script>




// WEBPACK FOOTER //
// src/components/map/MapDrawer.vue